module.exports = "pegasus/assets/blocks/column-lp6-basic.png";